import { useTranslation } from 'react-i18next';
import officeLogoRU from '#/shared/assets/logos/r7-office_Light_RU.svg';
import officeLogoEN from '#/shared/assets/logos/r7_office_Light_EN.svg';

interface LogoProps {
  height?: number;
  className?: string;
}

export const OfficeLogo = ({ height = 30, className = '' }: LogoProps) => {
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.language;
  const officeLogo = currentLanguage === 'ru' ? officeLogoRU : officeLogoEN;

  return <img className={className} src={officeLogo} alt={t('officeLogoAlt')} height={height} />;
};
